import { Pressable, StyleSheet, View } from 'react-native';
import { Brain, ChevronRight } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { AssistantPromptViewModel } from '../../types/aiAssistant';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type LearningProfilePromptCardProps = {
  prompts: AssistantPromptViewModel[];
  onPressPrompt: (prompt: AssistantPromptViewModel) => void;
};

export function LearningProfilePromptCard({
  prompts,
  onPressPrompt,
}: LearningProfilePromptCardProps) {
  if (!prompts.length) {
    return null;
  }

  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <Brain size={18} color={tokens.colors.primary} />
        <AppText variant="body" weight="bold">
          学习画像
        </AppText>
      </View>
      {prompts.map((prompt) => (
        <Pressable
          key={prompt.id}
          accessibilityRole="button"
          onPress={() => onPressPrompt(prompt)}
          style={({ pressed }) => [styles.promptRow, pressed ? styles.pressed : null]}
        >
          <View style={styles.promptCopy}>
            <AppText variant="body" weight="semibold">
              {prompt.title}
            </AppText>
            <AppText variant="caption" tone="muted">
              {prompt.subject}
            </AppText>
          </View>
          <ChevronRight size={18} color={tokens.colors.textMuted} />
        </Pressable>
      ))}
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  promptRow: {
    minHeight: 48,
    borderRadius: tokens.radius.md,
    paddingHorizontal: tokens.spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: tokens.colors.background,
  },
  promptCopy: {
    flex: 1,
    gap: 2,
  },
  pressed: {
    opacity: 0.86,
  },
});
